"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
/**
 * Defines a serialised contract that can be exchanged between services.
 * This interface should not be implemented directly, but via the
 * Command or Event interfaces.
 */
class Message {
}
exports.Message = Message;
